import React from "react";
import { cloudImg } from "../services/api";
import { formatPrice } from "../utils/currency";
import { TAG_LABELS } from "../i18n/strings";

// Per-menu-item card in the main menu grid: image, chef-pick star,
// name in the selected language, dietary tag chips, description,
// price, and the add / quantity stepper controls.
export default function MenuItemCard({
  item,
  inCart,
  addOne,
  removeOne,
  pickName,
  pickDescription,
  lang,
  t,
  currency,
}) {
  const img = cloudImg(item.image_url, 400);
  return (
    <div className="card">
      <div className="thumb">
        {img ? (
          <img
            src={img}
            alt={item.name}
            loading="lazy"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        ) : (
          <div className="thumb-fallback">{item.name.slice(0, 1)}</div>
        )}
      </div>
      <div className="name" lang={lang}>
        {item.is_chef_pick && (
          <span
            title={item.chef_pick_note || "Chef's pick"}
            aria-label="Chef's pick"
            style={{
              color: "#d4af37",
              marginRight: 4,
              fontSize: "0.95em",
            }}
          >
            ⭐
          </span>
        )}
        {pickName(item)}
      </div>
      {Array.isArray(item.dietary_tags) && item.dietary_tags.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 4 }}>
          {item.dietary_tags.map((slug) => {
            const opt = TAG_LABELS[slug];
            if (!opt) return null;
            return (
              <span
                key={slug}
                title={opt[lang] || opt.en}
                style={{
                  background: opt.color,
                  color: "#fff",
                  fontSize: "0.68rem",
                  padding: "1px 6px",
                  borderRadius: 999,
                  fontWeight: 600,
                }}
              >
                {opt.icon ? `${opt.icon} ` : ""}
                {opt[lang] || opt.en}
              </span>
            );
          })}
        </div>
      )}
      {pickDescription(item) && <div className="desc">{pickDescription(item)}</div>}
      <div className="row">
        <span className="price">{formatPrice(item.price, currency)}</span>
        {inCart === 0 ? (
          <button
            className="btn tap-feedback"
            onClick={() => addOne(item)}
          >
            {t("add")}
          </button>
        ) : (
          <div className="qty">
            <button
              className="tap-feedback"
              onClick={() => removeOne(item)}
              aria-label="Remove one"
            >
              &minus;
            </button>
            <span>{inCart}</span>
            <button
              className="tap-feedback"
              onClick={() => addOne(item)}
              aria-label="Add one"
            >
              +
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
